function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7984 53.8099C25.8381 50.6622 22.719 48.2141 19.5999 47.8643C18.2137 47.5146 15.2332 47.3048 14.4015 49.2633C13.3618 51.7114 14.4015 53.8099 16.8274 55.9083C19.2534 58.0067 23.7587 56.9575 24.7984 53.8099Z",
  stroke: "currentColor",
  strokeWidth: 4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.7404 49.2633C38.661 48.2141 36.9282 47.8643 34.1557 50.3125C32.7726 51.3617 32.0763 53.8099 33.4626 55.2088C34.8488 56.6077 38.3145 58.0067 42.1267 55.9083C45.9389 53.8099 42.8198 50.3125 40.7404 49.2633Z",
  stroke: "currentColor",
  strokeWidth: 4
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4122 10.0928C19.5306 15.6886 16.7119 33.6417 15.7877 41.9188C15.6665 42.968 24.7984 46.4654 26.1847 45.4162C26.1847 44.367 27.5709 38.0717 29.3038 33.5251C30.69 29.8879 36.3506 19.8854 39.0076 15.3388C39.2386 14.8725 39.4235 13.73 38.3145 12.8907C35.2647 11.2119 28.9572 9.62646 26.1847 9.04356C25.7226 8.92698 24.5212 8.97362 23.4122 10.0928Z",
  stroke: "currentColor",
  strokeWidth: 4
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M51.484 13.9399C47.8797 14.7792 40.0473 32.9422 36.5816 41.9188C36.173 42.968 45.5923 47.8643 45.5923 46.4654C49.058 37.0225 65 23.7325 65 21.6341C65 19.5357 53.9099 12.8907 51.484 13.9399Z",
  stroke: "currentColor",
  strokeWidth: 4
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.907fe446.svg";
export { ForwardRef as ReactComponent };